function claimForm() {
  let maxDate = new Date();
  maxDate.setDate(maxDate.getDate());
  $('#claim_claimDate').datetimepicker({
    format: 'DD.MM.YYYY',
    locale: 'cs',
    maxDate: maxDate,
  });

  var claimSubmit = {
    submitButton: $('#claim_submit'),
    onlyNumbers: $('.only-numbers'),

    init: function () {
      this.form = this.submitButton.closest('form');

      var app = this;
      this.onlyNumbers.keyup(function () {
        $(this).val($(this).val().replace(/\D/g, ''));
      });
      this.submitButton.on('click', function (event) {
        $('.form-error').remove();
        if (app.form[0].checkValidity()) {
          event.preventDefault();
          $('.form-error').remove();
          app.submitForm(app.form.serialize());
        }
      });
    },
    submitForm: function (serializedForm) {
      var app = this;
      $.ajax({
        url: this.form.attr('action'),
        method: 'POST',
        data: serializedForm,
        beforeSend: function () {
          app.disableButton(true);
        },
        success: function (response) {
          app.submitFormDefault();
        },
        error: function (response) {
          app.showMessage(response.responseJSON.message, 'error');
        },
        complete: function (jqXHR, status) {
          app.enableButton();
          app.form[0].reset();
        },
      });
    },
    showMessage: function (message, type) {
      toastr[type](message);
    },
    disableButton: function () {
      this.submitButton.attr('disabled', 'disabled');
    },
    enableButton: function () {
      this.submitButton.attr('disabled', false);
    },
    submitFormDefault: function () {
      this.form.submit();
    },
  };

  $(function () {
    claimSubmit.init();
  });
}
